import script from "./PremialitaComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PremialitaComponent.vue?vue&type=script&setup=true&lang=js"

import "./PremialitaComponent.vue?vue&type=style&index=0&id=29ae5e30&lang=css"

const __exports__ = script;

export default __exports__